export default "__VITE_ASSET__9BZiMeq8__"